module.exports = __webpack_public_path__ + "img/allStars_logo_dark.a1090d83.png";